import UserMenu from '../../../components/UserMenu/UserMenu';
import TeamSelector from '../../../components/UserMenu/components/TeamSelector/TeamSelector';
import UserMenuButton from '../../../components/UserMenu/components/UserMenuButton/UserMenuButton';
import { useOfflineUserMenu } from './hooks/useOfflineUserMenu';

const OfflineUserMenu = () => {
  const { buttonProps, menuProps, teamMenuProps } = useOfflineUserMenu();

  return (
    <>
      <UserMenuButton {...buttonProps} />
      <UserMenu {...menuProps} />
      <TeamSelector {...teamMenuProps} />
    </>
  );
};

export default OfflineUserMenu;
